import { environment } from 'src/environments/environment';
import { AuthService } from './../service/auth.service';
import { Component, OnInit } from '@angular/core';
import { GoogleLoginProvider, SocialAuthService, SocialUser } from '@abacritt/angularx-social-login';
import { Observable, of, map, Subject, mergeAll, merge, tap, shareReplay, BehaviorSubject, combineLatest, catchError, first, concatMap, filter } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  constructor(private auth: AuthService, private router: Router, private authService: SocialAuthService) {

  }

  ngOnInit(): void {
    this.authService.authState.subscribe((user:SocialUser) => {
      this.testLogin(user.email.split('@')[0]);
    })
  }

  login() {

  }

  testLogin(stno: string) {
    console.log('stno:' + stno)
    this.auth.loginForTesting(stno, false);
    this.router.navigate(['/'])
  }

  logout() {
    this.auth.signOut();
  }
}
